import { Box, Typography, Alert } from '@mui/material';
import { SDialog, StyledTextField } from '@modules/ui-components';
import { usePaddleWebhookSecretForm } from '@modules/paddle-connect/hooks/usePaddleWebhookSecretForm';
import { PADDLE_CONNECT_TEST_IDS } from '@modules/paddle-connect/testIds';

interface Props {
  environment: 'sandbox' | 'production';
  onSave: (secret: string) => Promise<void>;
  onSaved: () => void;
  onClose: () => void;
}

export function PaddleWebhookSecretDialog({ environment, onSave, onSaved, onClose }: Props) {
  const { secret, changeSecret, saving, error, save } = usePaddleWebhookSecretForm(onSave, onSaved);
  const name = environment === 'sandbox' ? 'Sandbox' : 'Production';
  return <SDialog open fullWidth maxWidth="sm" title={`${name} webhook secret`}
    data-testid={PADDLE_CONNECT_TEST_IDS.secretDialog}
    onClose={() => { if (!saving) onClose(); }} disableEscapeKeyDown={saving}
    primaryAction={{ label: saving ? 'Saving…' : 'Save secret', onClick: save, loading: saving,
      disabled: saving || !secret.trim(), 'data-testid': PADDLE_CONNECT_TEST_IDS.secretSave }}>
    <Box component="form" onSubmit={event => { event.preventDefault(); void save(); }} sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="body2" color="text.secondary">
        In Paddle {name}, open Developer Tools → Notifications → your destination and copy its secret key.
      </Typography>
      <StyledTextField label="Webhook signing secret" type="password" value={secret} onChange={changeSecret}
        autoFocus autoComplete="off" fullWidth disabled={saving} required
        trackFieldUpdates={false} showUpdateIndicator={false}
        slotProps={{ htmlInput: { 'data-testid': PADDLE_CONNECT_TEST_IDS.secretInput } }}
        placeholder="pdl_ntfset_…" helperText="Your existing API key and client token are kept."
        error={Boolean(error)} />
      {error && <Alert severity="error" role="alert">{error}</Alert>}
      <Typography variant="caption" color="text.secondary">
        Saving enables signature checks. Send a test event from Paddle to verify delivery.
      </Typography>
    </Box>
  </SDialog>;
}
